/**
 * @owner @Appboy/sms
 */

// generated from 4_923 samples

import { z } from "zod";
import { common } from "../common";
import { triggerAdditionalKeywordFiltersGetSchema } from "./triggerAdditionalKeywordFiltersGetSchema";

export const sentSmsInboundMessageTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::SentSmsInboundMessage"),
  // undefined: 56 (1.14%), defined 4_867 (98.86%)
  additional_keyword_filters: triggerAdditionalKeywordFiltersGetSchema.optional(),
  keyword_category: z.object({
    // null: 3_415 (69.37%)
    id: common.objectId.nullable(),
    // null: 82 (1.67%)
    name: z.string().nullable(),
  }),
  subscription_group: z.object({
    id: common.objectId,
    name: z.string(),
  }),
});
